export const API_KEY = '9pSPCUbvfbJz2w3W8RJovulO3PcZQdeF'

export const API_URL = 'https://api.giphy.com/v1'